module.exports = __webpack_public_path__ + "static/media/receive-pkt-bg.e70bedcc.svg";